module.exports = __webpack_public_path__ + "static/media/java.00d7cdd3.svg";